// Webpack entry point for Avatar Application
// Import CSS
import '../css/avatar.css';

// Import Three.js from node_modules (no more CDN)
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';

// Make THREE global for debugging and compatibility
window.THREE = THREE;
window.OrbitControls = OrbitControls;
window.GLTFLoader = GLTFLoader;
window.DRACOLoader = DRACOLoader;

// Import avatar modules
import './glb-cache.js';
import './avatar.js';
import './avatar-controls.js';

console.log('🚀 Avatar application loaded with Webpack!');
console.log('✅ Three.js version:', THREE.REVISION);
